import { useGetDocumentOrderFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const OrdersStatusFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentOrderFilterDimensions(cardCodes);

  const statusOptions: FilterOption[] = removeNullable(
    data?.documentStatuses?.map((status) => ({
      label: status.Name,
      value: status.Code,
    })) ?? []
  ).reverse();

  return (
    <CheckboxListFilter
      filterKey="status"
      name="Status"
      variant={variant}
      filterOptions={statusOptions}
      isLoading={isLoading}
    />
  );
};
